import { z } from 'zod';
import { Permissions } from '../permissions';

export const BackofficeUserPermissionsSchema = z.array(Permissions.exclude([Permissions.enum.DEFAULT]));

export const BackofficeUserSchema = z.object({
  id: z.uuid(),
  email: z.email(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  permissions: BackofficeUserPermissionsSchema,
});

export const BackofficeUserCreationBody = BackofficeUserSchema.omit({
  id: true,
  firstName: true,
  lastName: true,
}).transform((user) => ({
  ...user,
  email: user.email.toLowerCase(),
}));

export const BackofficeUsersGetResponseSchema = z.array(BackofficeUserSchema);
export const BackofficeUsersPostResponseSchema = BackofficeUserSchema;
export const BackofficeUserDeleteParamsSchema = z.object({ id: z.string().uuid() });
export const BackofficeUserPatchParamsSchema = z.object({ id: z.string().uuid() });
export const BackofficeUserPatchBodySchema = z.object({
  permissions: BackofficeUserPermissionsSchema,
});
export const BackofficeUsersPatchResponseSchema = BackofficeUserSchema;

export type BackofficeUsersGetResponseType = z.infer<typeof BackofficeUsersGetResponseSchema>;
export type BackofficeUserCreationBodyType = z.infer<typeof BackofficeUserCreationBody>;
export type BackofficeUsersPostResponseType = z.infer<typeof BackofficeUsersPostResponseSchema>;
export type BackofficeUserDeleteParamsType = z.infer<typeof BackofficeUserDeleteParamsSchema>;
export type BackofficeUserPatchParamsType = z.infer<typeof BackofficeUserPatchParamsSchema>;
export type BackofficeUserPatchBodyType = z.infer<typeof BackofficeUserPatchBodySchema>;
export type BackofficeUsersPatchResponseType = z.infer<typeof BackofficeUsersPatchResponseSchema>;
